import React from "react";
import { Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";

import HeaderBarcode from "../../shared/HeaderBarcode/HeaderBarcode";
import BackToStageButton from "../BackToStageButton/BackToStageButton";
import TopRightIcons from "../../shared/TopRightIcons/TopRightIcons";
import ChallengeInfo from "../../UI/ChallengeInfo/ChallengeInfo";

const Header = ({
  hints = {},
  delayTime,
  stageName,
  activeIcon,
  onDownload, // function to start download
  handlePause,
  challengeName,
  handleSaveRef,
  handleShowHint,
  handleCalculator,
  isReset = false,
  isShowCalculator,
  isShowStickyNote,
  handleStickyNotes,
  handleActivateIcon,
  setShowInstruction,
  handleMagnifierRef,
  highlightedIcon = false,
  showMagnifierRef = false,
  isZoomIn, // Default to zoom in icon
  isShowDownload = false,
  isDownloadComplete = false,
  handleResetLevel = () => {},
}) => {
  const navigate = useNavigate();
  const hintTextLength = hints.text?.length || 0;
  const isHintDisabled = !hints.text?.length;

  return (
    <Stack direction="row" className="header" justifyContent="space-between">
      <HeaderBarcode />

      <Stack
        direction="row"
        useFlexGap
        gap={4}
        alignItems="flex-end"
        className="header-left"
      >
        <BackToStageButton
          handleBackToStage={() => navigate(`/${stageName}`)}
          active={highlightedIcon === "back"}
        />
        <ChallengeInfo challengeName={challengeName} />
      </Stack>

      <TopRightIcons
        isZoomIn={isZoomIn}
        delayTime={delayTime}
        isRearrange={isReset}
        onDownload={onDownload}
        activeIcon={activeIcon}
        disabled={isHintDisabled}
        handlePause={handlePause}
        handleSave={handleSaveRef}
        handleHint={handleShowHint}
        badgeContent={hintTextLength}
        isShowDownload={isShowDownload}
        highlightedIcon={highlightedIcon}
        handleRearrange={handleResetLevel}
        setActiveIcon={handleActivateIcon}
        showMagnifierRef={showMagnifierRef}
        handleCalculator={handleCalculator}
        isShowCalculator={isShowCalculator}
        isShowStickyNote={isShowStickyNote}
        handleStickyNotes={handleStickyNotes}
        handleMagnifierRef={handleMagnifierRef}
        isDownloadComplete={isDownloadComplete}
        handleInstruction={() => setShowInstruction(true)}
      />
    </Stack>
  );
};

export default React.memo(Header);
